import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "contact");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Contact | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="contact-container">
						<div className="title contact-title">
							Let's Get in Touch: Ways to Connect with Me
						</div>

						<div className="subtitle contact-subtitle">
  Thanks for taking the time to reach out. If you're interested in collaborating,
  discussing a project, or exploring full-stack development opportunities, feel free
  to connect with me.

  The best way to reach me is by email at{" "}
  <a href={`mailto:${INFO.main.email}`}>
    {INFO.main.email}
  </a>
  . I personally review every message and do my best to respond promptly with
  clarity and value — not generic replies.

  You can also find me sharing updates, dev content, and project breakdowns on{" "}
  <a
    href={INFO.socials.twitter}
    target="_blank"
    rel="noreferrer"
  >
    Twitter
  </a> and&nbsp;
  <a
    href={INFO.socials.linkedin}
    target="_blank"
    rel="noreferrer"
  >
    Linkedin
  </a>
  . Whether you have a specific idea in mind or just want to say hello, don't
  hesitate to reach out — building cool things always starts with a conversation.
</div>

					</div>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
